import { BaseOauthClient } from "./base";

export class GoogleSheetsOauthClient extends BaseOauthClient {
  provider = "google_sheets";
  baseUrl = "https://accounts.google.com";
  authorizationEndpoint = '/o/oauth2/v2/auth';
  tokenEndpoint = "https://oauth2.googleapis.com/token";

  clientId = process.env.GOOGLE_CLIENT_ID || "";
  clientSecret = process.env.GOOGLE_CLIENT_SECRET || "";

  scopes = [
    "https://www.googleapis.com/auth/spreadsheets.readonly",
    "https://www.googleapis.com/auth/drive.readonly"
  ];
  extraParams = {
    access_type: "offline",
    prompt: "consent",
  };

  constructor(team: string, supabaseClient: any, id: string, credentials?: { clientId: string, clientSecret: string }) {
    super(team, supabaseClient, id, credentials);
    this.initializeOauthClient();
  }

  async getRecords(docId: string, sheetName: string) {
    const url = `https://docs.google.com/spreadsheets/d/${docId}/gviz/tq?tqx=out:csv&sheet=${sheetName}`;
    // const url = `https://docs.google.com/feeds/download/spreadsheets/Export?key=${docId}&exportFormat=csv&gid=0`;
    let response = await this.fetcher.fetch(url);
    return response;
  }
}